import React, { useLayoutEffect } from 'react';
import FadeInImage from 'components/FadeInImage';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getRegion } from 'utils/Region';
import './style.scss';
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';
import { useProfiles } from 'containers/ProfileManager/hooks/useProfiles';
import {
  showMenuAvatar,
  showMenuAvatarMobile,
} from 'containers/MenuAvatar/actions/menuAvatar.actions';

export const AvatarContainer = ({ isMobil }) => {
  const { profilesEnable } = useProfiles();
  const user = useSelector(state => state.user);
  const claroAdEnable = useSelector(state => getClaroAdsKey(state));
  const profiles = useSelector(state => state.profilesManager.profilesInfo);
  const { home_anonymous_placeholder_img } = useSelector(state => state.asset);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const getAvatarImage = () => {
    if (!user?.user_id || !profilesEnable)
      return home_anonymous_placeholder_img;

    return profiles?.members?.find(
      member => member.gamification_id === user.gamification_id,
    )?.user_image;
  };

  const handleClick = e => {
    e.stopPropagation();
    if (!user?.user_id)
      return navigate(`/${getRegion()}/${claroAdEnable ? 'login' : 'landing'}`);

    if (isMobil) dispatch(showMenuAvatarMobile());
  };

  const handleHover = e => {
    e.stopPropagation();
    if (!isMobil) {
      dispatch(showMenuAvatar());
    }
  };

  return (
    <div
      className="cv-avatar-container"
      onClick={handleClick}
      onMouseEnter={e => handleHover(e)}
    >
      <FadeInImage
        imageSrc={getAvatarImage()}
        imageAlt="cv-avatar"
        width={32}
        height={32}
        classNames={['cv-avatar-container__img']}
      />
    </div>
  );
};
